import React from 'react';
import { observer, inject } from 'mobx-react';
import { checkIfDefaultExceptionFlow, checkIfBothExceptionFlow, parseExceptionConfig } from './utils';
import DeliveryReceiptDetailsDefault from './DefaultExceptionFlow/DeliverReceiptDetails';
import DeliveryReceiptDetailsADE from './ADEExceptionFlow/DeliverReceiptDetails';
import DeliveryReceiptDetailsBoth from './BothExceptionFlow/DeliverReceiptDetails';
import { withAppConfig } from '../../../../../../../../appConfigContext';
import { compose } from 'recompose';
import FormSectionHeader from '../../common/FormSectionHeader';

const DeliveryReceiptExceptionDetails = ({ exceptionDetails, configJSON, DispatchStore }) => {
  const exceptionConfig = parseExceptionConfig(configJSON?.exceptionConfig);
  const exceptionFlow = exceptionConfig?.exceptionFlow;
  const isDefaultExceptionFlow = checkIfDefaultExceptionFlow(exceptionFlow);
  const isBothExceptionFlow = checkIfBothExceptionFlow(exceptionFlow);
  const isMultipleExceptionsEnabled = configJSON?.enableMultipleExceptionDetails;

  const getExceptionDescription = (code) => {
    if (!code) return '';
    return DispatchStore.getExceptionDetails(code)?.description || '';
  };

  return (
    <>
      <FormSectionHeader label="EXCEPTION DETAILS" />

      {isBothExceptionFlow ? (
        <DeliveryReceiptDetailsBoth
          exceptionDetails={exceptionDetails} // full array [ADE, ...Default]
          packageTypeList={DispatchStore.packageCodes || []}
          getExceptionDescription={getExceptionDescription}
          isMultipleExceptionsEnabled={isMultipleExceptionsEnabled}
          configJSON={configJSON}
          DispatchStore={DispatchStore}
        />
      ) : (
        exceptionDetails?.map((exception, index) =>
          isDefaultExceptionFlow ? (
            <DeliveryReceiptDetailsDefault
              key={index}
              index={index}
              exceptionDetails={exception}
              packageTypeList={DispatchStore.packageCodes || []}
              getExceptionDescription={getExceptionDescription}
              isMultipleExceptionsEnabled={isMultipleExceptionsEnabled}
            />
          ) : (
            <DeliveryReceiptDetailsADE
              key={index}
              index={index}
              exceptionDetails={exception}
              getExceptionDescription={getExceptionDescription}
              configJSON={configJSON}
              DispatchStore={DispatchStore}
            />
          )
        )
      )}
    </>
  );
};

export default compose(withAppConfig, inject('DispatchStore'))(observer(DeliveryReceiptExceptionDetails));
